import $ from "jquery";

export const bindOtpInputs = (selector = '.mi-login__otp-digit', maxLength = 5) => {
    $(selector).each(function (index) {
        const inputs = $(selector);

        $(this).on('input', function () {
            $(this).val($(this).val().replace(/[^0-9]/g, ''));
            if ($(this).val()) {
                $(this).addClass('is-filled');
                if (index < inputs.length - 1) inputs.eq(index + 1).focus();
            } else {
                $(this).removeClass('is-filled');
            }
        });

        $(this).on('keydown', function (e) {
            if (e.key === 'Backspace' && !$(this).val() && index > 0) {
                inputs.eq(index - 1).focus();
            }
        });

        $(this).on('paste', function (e) {
            e.preventDefault();
            const pasted = (e.originalEvent.clipboardData || window.clipboardData).getData('text').replace(/[^0-9]/g, '');
            pasted.split('').slice(0, maxLength).forEach((char, i) => {
                if (inputs.eq(i).length) {
                    inputs.eq(i).val(char).addClass('is-filled');
                }
            });
            inputs.eq(Math.min(pasted.length, inputs.length - 1)).focus();
        });
    });
};